import React, {
  PropTypes as T,
} from 'react';
import radium from 'radium';
import _ from 'lodash';
import * as ReservationActions from '../../actions/Reservation.js';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const styles = {
  wrap: {
    width: 417,
    borderRight: '1px solid #bfbfbf',
    padding: 0,
    overflow: 'auto',
  },
  activeCity: {
    color: '#A39671',
    fontSize: 30,
    margin: '25px 10px 10px 10px',
    letterSpacing: 10,
  },
  cityTitle: {
    backgroundColor: '#E2E2DB',
    display: 'block',
    lineHeight: '28px',
    padding: '0 10px',
    color: '#FBBB0C',
    fontSize: 20,
  },
  shopBlock: {
    padding: 15,
    boxSizing: 'border-box',
    borderBottom: '1px dashed #ccc',
    minHeight: 96,
    display: 'block',
    color: 'black',
    cursor: 'pointer',
  },
  name: {
    display: 'block',
    fontSize: 18,
    fontWeight: 'bold',
    padding: '5px 0',
  },
  text: {
    maxWidth: 254,
    display: 'block',
    fontSize: 15,
    lineHeight: 1.5,
  },
};

function ReservationStoreList(props) {
  const {
    cityList,
    selectedCity,
    cities,
    openReservationModal,
  } = props;

  if (!cityList.length) return null;

  const activeCity = cities.find((city) => city.id === selectedCity);
  const groupCityList = _.groupBy(cityList, 'district');

  return (
    <div style={styles.wrap}>
      <h2 style={styles.activeCity}>{activeCity.name}</h2>
      {Object.keys(groupCityList).map((city, idx) => (
        <div key={idx} style={styles.districtBlock}>
          <span style={styles.cityTitle}>{city}</span>
          {groupCityList[city].map((shop) => (
            <span key={shop.id} style={styles.shopBlock} onClick={() => openReservationModal(shop)}>
              <span style={styles.name}>{shop.name}</span>
              <span style={styles.text}>{shop.tel}</span>
              <span style={styles.text}>{shop.addr}</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  );
}

ReservationStoreList.propTypes = {
  cityList: T.array,
  selectedCity: T.number,
  cities: T.array,
  openReservationModal: T.func,
};

export default connect(
  () => ({

  }),
  dispatch => bindActionCreators(ReservationActions, dispatch),
)(radium(ReservationStoreList));



// WEBPACK FOOTER //
// ./containers/Reservations/ReservationStoreList.js